import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { MAX_LENGTH } from "./Advice/Advice";
import { t, tl } from "../../components/translate";
import DebouncedTextField from "../../components/DebouncedTextField";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

const ProvisionalDiagnosis = ({
  assessmentProvisionalDiagnosis,
  onChange,
  isOpd = true
}: {
  assessmentProvisionalDiagnosis: string;
  onChange: (value: string) => void;
  isOpd?: boolean;
}): React.ReactNode => {
  const assessmentLabels = useAssessmentLabel();
  const [localValue, setLocalValue] = React.useState(assessmentProvisionalDiagnosis || "");

  useEffect(() => {
    setLocalValue(assessmentProvisionalDiagnosis || "");
  }, [assessmentProvisionalDiagnosis]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {isOpd ? assessmentLabels.provisionalDiagnosis : tl("assessment.provisionalDiagnosis")}
        </Typography>
      </Box>
      <Box className={styles.assessmentField}>
        <DebouncedTextField
          data-testmation="provisionalDiagnosisTextField"
          margin="dense"
          variant="outlined"
          fullWidth
          multiline
          maxRows={3}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { maxLength: MAX_LENGTH },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          value={localValue}
          placeholder={t("assessment.typeProvisionalDiagnosis")}
          onChange={(e) => {
            setLocalValue(e.target.value);
            onChange(e.target.value);
          }}
          debounceAt={400}
          helperText={`${localValue.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};

export default ProvisionalDiagnosis;
